import {
  defineNuxtPlugin,
  useCookie,
  useCookieConsent,
  useHead,
  useRuntimeConfig
} from "#imports";
import consola from "consola";
import { loadScripts } from "../utils/script.loader.mjs";
import { updateState } from "../utils/update.state.mjs";
export default defineNuxtPlugin(() => {
  const { cookieConsent: config } = useRuntimeConfig().public;
  if (!config.init || !config.dev && process.dev) {
    return;
  }
  if (config.init) {
    const cbid = config.cbid;
    if (!cbid) {
      consola.warn(
        'Unable to initialize CookieBot script: No Cookiebot CBID provided. Please set the `cbid` option in "cookieConsent" in `nuxt.config.js`'
      );
    } else {
      const consentMode = config.consentMode;
      const consentModeDefaults = config.consentModeDefaults;
      useHead({
        script: [
          {
            id: "CookieBot",
            src: `https://consent.cookiebot.com/uc.js?cbid=${cbid}`,
            async: true,
            type: "text/javascript",
            tagPriority: 5,
            "data-consentmode": !consentMode ? "disabled" : void 0,
            "data-consentmode-defaults": !consentModeDefaults ? "disabled" : void 0
          }
        ]
      });
    }
  }
  const cookie = useCookie("CookieConsent", {
    decode: (value) => {
      try {
        return JSON.parse(
          decodeURIComponent(value || "{}").replace(/'/g, '"').replace(/([{[,])\s*([a-zA-Z0-9_]+?):/g, '$1"$2":')
        );
      } catch {
        return null;
      }
    }
  });
  const { state } = useCookieConsent();
  if (cookie.value) {
    updateState(state, {
      necessary: cookie.value.necessary || false,
      functional: cookie.value.preferences || false,
      statistic: cookie.value.statistics || false,
      marketing: cookie.value.marketing || false,
      unclassified: false
    });
  }
  if (import.meta.client) {
    window.addEventListener("CookiebotOnAccept", () => {
      if (!window?.Cookiebot?.consent) {
        return;
      }
      updateState(state, {
        necessary: window.Cookiebot.consent.necessary || false,
        functional: window.Cookiebot.consent.preferences || false,
        statistic: window.Cookiebot.consent.statistics || false,
        marketing: window.Cookiebot.consent.marketing || false,
        unclassified: false
      });
    });
  }
  loadScripts(config);
});
